import React, {useEffect} from "react";
import Header from "./header"
import Weather from "./weather";
import Axis from "./axis";
import AxisDetail from "./AxisDetail";
import Indicators from "./Indicators";
import Charts from "./Charts";
import {useDispatch, useSelector} from "react-redux";
import {loadAllAxis} from "../axis/all-axis/axisAction";
import {loadUsers} from "../user/usersAction";
import styled from "styled-components";
import {getImage} from "../../utils/utils";
import account from "../../images/account.svg";
import enjoyLogo from "../../images/logo_EYB/logoEYBFull.png";
import {loadProjects} from "../project/projects/projectsAction";

const EnjoyNews = React.forwardRef((props, ref) => {
    const chartsReady = false;
    const strategy = useSelector(state => (state.strategy))
    const {axis} = (useSelector(state => (state.axis)))
    const strategicAxis = axis.filter(a => a.isStrategic)
    const {users} = (useSelector(state => (state.users)))
    const ambassadors = users.filter(u => u.roles.includes("ROLE_AMBASSADOR"))
    const stakes = strategicAxis.map(a => a.stakes).flat()
    const strategicProjects = stakes.map(s => s.projects).flat()
    const filteredAxis = props.axis.length > 0 ? strategicAxis.filter(a => props.axis.includes(a.id)) : strategicAxis
    const filteredStakes = filteredAxis.map(a => a.stakes).flat()
    const filteredProjects = filteredStakes.map(s=> s.projects).flat()
    const {projects} = useSelector(state => (state.projects))
    //const strategicProjects = projects.filter(p => p.isStrategic)
    const dispatch = useDispatch();
    const appURL = 'https://' + process.env.REACT_APP_FQDN + '.enjoyapp.enjoyyourbusiness.fr';
    const avgAdvancement = () => {
        let avg = 0;

        strategicAxis.map(a => {
            return avg += a.stakeAdvancementAVG
        })
        return (avg / strategicAxis.length).toFixed(0)
    }
    useEffect(() => {
        dispatch(loadAllAxis());
        dispatch(loadUsers())
        dispatch(loadProjects())
    }, [dispatch])
    return (
            <EnjoyNewsStyle ref={ref}>
                <Header strategy={strategy} handlePrint={props.handlePrint}/>
                <Indicators strategy={strategy} countUsers={users.length} axis={strategicAxis} stakes={stakes} projects={strategicProjects}/>
                <AxisWeather >
                    <div className="axis-weather-container">
                        <Axis axis={strategicAxis} avg={avgAdvancement()}/>
                        <Weather projects={strategicProjects}/>
                    </div>
                    <div>
                        <p className="env-link">
                            RETROUVEZ LES DONNEES
                            DANS VOTRE SOLUTION ENJOY YOUR BUSINESS
                        </p>
                    </div>
                </AxisWeather>
                    <ProjectDetailByAxis>
                        {
                            props.axis.map( a => {
                                return <AxisDetail axis={a} key={a.id} pilotsId={props.pilots} years={props.years}
                                                   weathers={props.weathers} tags={props.tags} asideObjective={props.asideObjective} showKR={props.showKR} users={users}/>
                            })
                        }

                    </ProjectDetailByAxis>
                {
                    chartsReady &&

                    <div>
                        <Charts data={projects}/>
                    </div>
                }
                {
                    ambassadors &&
                    <AmbassadorBlock>
                        <div>
                            <h3>Une question ? contactez l'un de vos ambassadeurs enjoy :</h3>
                            <AmbassadorContainer>
                                { ambassadors.map(a => {
                                    return <AmbassadorCard key={a.id}>
                                            <img src={getImage(a.photo, account)} alt=""/>
                                            <p>{a.firstName} {a.lastName} </p>
                                        </AmbassadorCard>
                                })}
                            </AmbassadorContainer>
                        </div>
                        <div className="link">
                            <h5>Retrouvez les données de la stratégie dans votre solution Enjoy Your Business</h5>
                        </div>
                    </AmbassadorBlock>
                }
                <Logo>
                    <img src={enjoyLogo} alt="logo EYB"/>
                </Logo>
            </EnjoyNewsStyle>
        );
});
export default EnjoyNews;

const EnjoyNewsStyle = styled.div`
  display: none;
  margin: 0 2%;
  @font-face {
    font-family: Gilroy;
    src: url(../styles/Gilroy-Heavy/Gilroy-Heavy.ttf);
    src: url(../styles/Gilroy-Bold/Gilroy-Bold.ttf);
    src: url(../styles/Gilroy-Light/Gilroy-Light.ttf);
    src: url(../styles/Gilroy-Medium/Gilroy-Medium.ttf);
    src: url(../styles/Gilroy-Regular/Gilroy-Regular.ttf);
  }
  @font-face {
    font-family: Gilroy-heavy;
    src: url(../styles/Gilroy-Heavy/Gilroy-Heavy.ttf);
  }

  @font-face {
    font-family: comfortaa;
    src: url(../styles/Comfortaa/Comfortaa-Bold.ttf);
    src: url(../styles/Comfortaa/Comfortaa-Light.ttf);
    src: url(../styles/Comfortaa/Comfortaa-Regular.ttf);
  }
  @media print{
    display: block;
  }
`

const AxisWeather = styled.section`
  max-width: 90%;
  margin: 0 auto;
  display: grid;
  grid-gap: 5rem;
  grid-template-columns: repeat(1, minmax(80%, 1fr));
  @media print{
    page-break-inside: avoid;
    grid-gap: 2rem;    
  }
  
  .axis-weather-container{
    display: grid;
    grid-template-columns: repeat(1, minmax(80%, 1fr));
    @media screen and (min-width: 900px){
      grid-template-columns: 60% 40%;
    }
    @media print{
      grid-template-columns: 60% 40%;
    }
    
  }
  
  .env-link{
    @media print{
      font-size: 11px;
      padding: 0.5rem 0;
      text-align: center;
    }
  }
`

const ProjectDetailByAxis = styled.section`
  display: flex;
  flex-direction: column;

  p {
    font-size: 24px;
    
  }
  h2{
    font-size: 35px;
    background: #4909aa;
    text-align: center;
    color: white;
    margin-top: 2rem;
    padding: 2rem 1rem;
  
`
const AmbassadorBlock = styled.div`
  
  display: flex;
  flex-direction: column;
  @media screen and (min-width: 900px) {
    display: grid;
    grid-gap: 2rem;
    grid-template-columns: 60% 40%;
  }

  @media print{
    page-break-before: always;
  }
  
  h3 {
    font-family: 'Archivo Black', sans-serif;
    color: var(--color-purple);
    text-transform: uppercase;
    padding: 0.5rem;
    font-size: 20px;
    margin: 2rem 0 ;
    @media screen and (min-width: 900px){
      font-size: 30px;
      
    }
  }
  .link{
    display: flex;
    flex-direction: column;
    max-width: 80%;
    margin-top: 2rem;
    word-wrap: break-word;
    @media screen and (max-width: 900px){
      max-width: 100%;
      gap: 1rem;
      align-self: flex-end;
      padding: 1rem;
    }
  }
  h5{
    text-transform: uppercase;
    font-size: 20px;
    @media screen and (min-width: 900px){
      text-align: right;
      font-size: 26px;

    }
  }
  a{
    text-transform: uppercase;
    color: var(--color-purple);
    font-size: 20px;
    @media screen and (min-width: 900px){
      text-align: right;
      font-size: 26px;

    }
  }
`

const AmbassadorContainer = styled.div`
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(2, minmax(20%, 50%));
`
const AmbassadorCard = styled.div`
  display:flex;
  align-items: center;
  gap: 0.5rem;
  background: #eee;
  border-radius: 15px;
  padding: 0.5rem;
  
  p{
    font-size: 20px;
    
    @media print{
      font-size: 18px;
    }
  }

  img {
    border-radius: 50%;
    height: 60px;
    width: 60px;
  }
`
const Logo = styled.div`
  max-width: 80%;
  margin: 4rem auto auto auto;
  img{
    max-width: 100%;
  }
`
//ReactDom.render(<EnjoyNews countUsers={countUsersData} axis={axisData} strategy={strategyData} appFQDN={appFQDNData} apiFQDN={apiFQDNData}/>, EnjoyElement)